import { api } from "../../../api";

export class KBService {
  async fetchEntries(limit = 100) {
    return await api(`/kb/?limit=${limit}`);
  }

  async searchEntries({ query, top_k = 20 }) {
    return await api("/kb/search", {
      method: "POST",
      body: JSON.stringify({ query, top_k }),
    });
  }

  async createEntry(entryData) {
    return await api("/kb/", {
      method: "POST",
      body: JSON.stringify(entryData),
    });
  }

  async updateEntry(id, entryData) {
    return await api(`/kb/${id}`, {
      method: "PUT",
      body: JSON.stringify({
        title: entryData.title,
        issue_type: entryData.issue_type,
        description: entryData.description,
        root_cause: entryData.root_cause,
        resolution: entryData.resolution,
      }),
    });
  }

  async deleteEntry(id) {
    return await api(`/kb/${id}`, {
      method: "DELETE",
    });
  }
}

export const kbService = new KBService();

// Delegators for backward compatibility / direct imports
export const fetchEntries = (limit) => kbService.fetchEntries(limit);
export const searchEntries = (params) => kbService.searchEntries(params);
export const createEntry = (data) => kbService.createEntry(data);
export const updateEntry = (id, data) => kbService.updateEntry(id, data);
export const deleteEntry = (id) => kbService.deleteEntry(id);
